import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { SoggettoEditorComponent } from 'src/app/shared/components/soggetto-editor/soggetto-editor.component';
import { SoggettoDialogComponent } from 'src/app/shared/components/soggetto-dialog/soggetto-dialog.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { GestioneIndirizziProvissoriComponent } from './components/gestione-indirizzi-provvisori/gestione-indirizzi-provvisori.component';
import { GestioneIndirizziComponent } from './gestione-indirizzi.component';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    ButtonModule,
    DialogModule,
    ToastModule,
    InputTextModule,
    DropdownModule,
    TableModule,
    SoggettoEditorComponent,
    SoggettoDialogComponent
  ],
  exports: [
    GestioneIndirizziComponent
  ],
  declarations: [
    GestioneIndirizziComponent,
    GestioneIndirizziProvissoriComponent
  ],
  providers: [],
})
export class GestioneIndirizziModule { }
